import React, { useState, useEffect } from 'react';
import { Form, Col, Modal } from 'react-bootstrap';
import WofButton from '../../WofButton';
import { StationModalType } from '../../../types';

const StationModal: React.FC<StationModalType> = ({
  img,
  description,
  btnCloseText,
  show,
  onHide,
 onClose,
 onChange,
 onSelect
}) => 
  {
    const [initialValue, setInitialValue] = useState('');
 useEffect(() => {
    if (initialValue) {
      onChange(initialValue);
    }
  }, [initialValue, onChange]);
return(
  <React.Fragment>
   <Modal
    show={show}
    onHide={onHide}
    size="lg"
    className="not-station-modal"
    aria-labelledby="contained-modal-title-vcenter"
    centered>
    <Modal.Body>
      <div className={"find-station"}>Find Your station?</div>  
      <Form.Group
      as={Col}
      lg="12"
      className="ga-field"
      >
      <Form.Label className="ga-form-label" style={{color:'#000'}}>{"Enter your Zip Code"}</Form.Label>
      <Form.Control
        placeholder={"Zip Code"}
        className="ga-text"
        type={"text"}
        value={img}
        defaultValue={initialValue}
        onChange={(v: any) => onChange(v.target.value)}
        required
        id={"StationModalText"}
      />
      <Form.Control.Feedback className="ga-error" type="invalid">
        {"Please enter Zip Code"}
      </Form.Control.Feedback>
    </Form.Group>
    <WofButton
          id={"CarouselId"}
          onClick={onClose}>
          {"SUBMIT"}
        </WofButton>

        {(description) ? <div className={"search-block"}>
        <h2 style={{display:'block'}}>Search Results</h2>
        <div id="not-your-station-result" style={{display:'block'}}>
        <table id="listing-results">
        <tbody>
        {description.station_name ? <><tr><th>Station</th><th>Time</th></tr>
        <tr><td>{description.station_name}</td><td>{description.tune_in_info}</td></tr></> :  <tr><td>No Station found</td></tr>}
        </tbody>
        </table>
        </div>  {(description.station_name) ? <WofButton
          id={"CarouselId"}
          onClick={onSelect}>
          {"Select"}
        </WofButton> : null}</div> : null}
     
    </Modal.Body>

  </Modal>
   </React.Fragment>)

  };

export default StationModal;